<template>
  <div class="row">
    <div class="col-12 text-right">
      <dropzone
        id="photos"
        :url="photoUrl"
        :auto-process-queue="false"
        ref="photoUpload"
        accepted-file-types="image/*"
        :clickable="!readonly"
        param-name="photo"
        v-on:vdropzone-removed-file="deletePhoto"
        updateMultiple="true"
      ></dropzone>
      <button
        v-if="!readonly"
        class="btn btn-primary half-gutter-top"
        v-on:click.prevent="uploadPhotos"
      >
        Upload Photos
      </button>
      <hr />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      photos: []
    };
  },

  computed: {
    photoUrl() {
      return window.AxisUK.api + '/incidents/' + this.incident + '/photos';
    }
  },

  mounted() {
    this.getPhotos();
  },

  methods: {
    uploadPhotos() {
      this.$refs.photoUpload.setOption('headers', {
        Authorization: 'Bearer ' + window.Token.get()
      });

      this.$refs.photoUpload.processQueue();
    },
    getPhotos() {
      window.Ajax.get('/incidents/' + this.incident + '/photos')
        .then(response => {
          this.$refs.photoUpload.removeAllFiles();
          response.data.photos.forEach(photo => {
            photo = `${photo}?token=${window.Token.get()}`;

            let data = {
              name: photo,
              size: 12345
            };

            this.$refs.photoUpload.manuallyAddFile(data, photo, null, true, {
              dontSubstractMaxFiles: false,
              addToFiles: true
            });
          });
        })
        .catch(error => {});
    },
    deletePhoto(file, error, xhr) {
      if (this.readonly) {
        return;
      }
      window.Ajax.delete(file.name).catch(error => {
        this.indicator = false;
        window.toastify.error(
          'Error',
          'Sorry, there was an error when deleting the photo.'
        );
      });
    }
  }
};
</script>
